export const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
export const ellipsied = (str: string, length: number) =>
  str.length > length ? `${str.slice(0, length)}...` : str
